module.exports = __webpack_public_path__ + "img/backgzt.402fcfdf.png";